<atl-ngb-modal-header class="configure-builder-modal__header" 
    (closeModalEvent)="closeModal()" 
    [isClient]="false"
    [title]="'Title.Share_showroom'">
</atl-ngb-modal-header>

<div class="d-flex share-modal__content v-scrollbar flex-column">
    <div class="p-24">
        <form class="mt-24" [formGroup]="form" class="d-inline-flex align-items-center w-100">
            <atl-input
              [placeholder]="'Input.Enter_Email.Placeholder'"
              formControlName="email"
              [label]="'Input.Email.Label'"
              [isBlurChange]="true"
              class="w-100"
          ></atl-input>
          <button class="newest-button mt-24 ml-8" [disabled]="form?.invalid" 
             (click)="confirm()">
                {{ 'Title.Share' | translate }}
          </button>

        </form>
    </div>
</div>

<footer class="share-modal__footer">
    <div [class.invisible]="!tokenLink" class="d-flex align-items-center justify-content-start h-100">
        <div class="d-flex" (click)="copyToClipBoard()">
            <span class="text-blue-980 cursor-pointer">
                <img class="mr-8 filter-icon-blue-980" src="/assets/unit_link.svg" alt="icon copy">
                <span class="fz-14 lh-24 fw-400">{{ !isShowMessageBanner ? ('Shared.Entity.Copy_link' | translate) : messageBannerText | translate }}</span>
            </span>
        </div>
    </div>
</footer>